import log from 'ololog';
import qi from 'q-i';

const basicLogger = log.configure({
  locate: true,
  time: true,
  stringify: { print: qi.stringify },
});

export const error = basicLogger.bright.red.error;

export const info = basicLogger.noLocate.info;

export const custom = log;
